import { Container, Rectangle, UPDATE_PRIORITY} from 'pixi.js'
import { app, gearContainer, mainContainer, viewportInstances } from '../app'
import { ViewportInstance } from '../classes/ViewportInstance';
import { ViewportSprite } from '../classes/ViewportSprite';
import { textAnimations, ViewportText } from '../classes/ViewportText';
import {Menu} from '../classes/Menu'
import { findSettingByID, saveSettings, settings, settingValue } from '../settings';
import { OutlineFilter } from 'pixi-filters';
import { Colourise } from '../assets/filters/Colourise';
import { currentPalette } from '../palettes';
import { pageOpen, transitionPage, transitionPageGroup } from '../main';
import { graphicsContainer } from '../classes/MenuGraphics';


export let mousePos = [4];

export let mouseDown = false;
export let heldDuration = 0.0;

export let menu: Menu;

export const colouriseFilter = new Colourise(0xff0000,0xff5555,0xaa0000)

export const headingsContainer = new Container();
headingsContainer.interactiveChildren = true;
export let menuHeading: ViewportText;
export let menuSubheading: ViewportText;
export let menuIndicator: ViewportText;

const outlineAndColourise = [
  colouriseFilter,
  new OutlineFilter({
        alpha: 1,
        thickness: 1,
        quality: 0.1,
        
    }),
    new OutlineFilter({
        alpha: 1,
        thickness: 2,
        quality: 0.1 
    })
]

export async function createDefault(): Promise<Container> {

  app.stage.eventMode = 'static'
  app.stage.hitArea = app.screen;

  mousePos[0] = 0.5;
  mousePos[1] = 0.5;
  mousePos[2] = app.screen.width/2;
  mousePos[3] = app.screen.height/2;

  mainContainer.sortableChildren = true;
  
  menu = new Menu();
  menu.zIndex = 1; //menu above everythign
  console.log(menu.zIndex)

  const outlineOnly = [
    new OutlineFilter({
        alpha: 1,
        thickness: 1,
        quality: 0.1,
        
    }),
    new OutlineFilter({
        alpha: 1,
        thickness: 2,
        quality: 0.1 
    })
]



  const reserves = new ViewportSprite(
    {
      destContainer: gearContainer, 
      spriteRef: 'jamjar',
      perX: 0.87, 
      perY: 0.066, 
      minWidth: 0.075,   
      clickFunction: () => menuButton(2),
      customFilters: outlineAndColourise,
      hitAreaMult: 0.7
    }
  )
  const gear = new ViewportSprite(
    {
      destContainer: gearContainer, 
      spriteRef: 'gear',
      perX: 0.96, 
      perY: 0.07, 
      minWidth: 0.04,   
      clickFunction: () => menuButton(3),
    }
  )
  const help = new ViewportText(
    {
      destContainer: gearContainer,
      content: '?', 
      size: 60, 
      textAnimation: textAnimations.none, 
      perX: 0.04,
      perY: 0.07,
      minWidth: 0.03, 
      clickFunction: () => menuButton(0)
    }
  )
  help.lightColours = true;
  // const helpText = new ViewportText(mainContainer,'help',80, 0.04, 0.17, 0.05)
  
  const world = new ViewportSprite(
    {
      destContainer: gearContainer, 
      spriteRef: 'earth',
      perX: 0.1, 
      perY: 0.047, 
      minWidth: 0.075,   
      clickFunction: () => menuButton(1),
      customFilters: outlineOnly,
      secondaryRef: 'clouds',
      hitAreaMult: 0.6
    }
  )
  // const worldText = new ViewportText(mainContainer,'world',80, 0.12, 0.17, 0.05)

  menuHeading = new ViewportText(
    {
      destContainer: headingsContainer, 
      content: 'Settings', 
      size: 60, 
      textAnimation: textAnimations.none,
      perX: 0.5, 
      perY: 0.075, 
      // maxWidth: 0.3,
      minHeight: 0.15,
      maxHeight: 0.3
    }
  );
  menuSubheading = new ViewportText(
    {
      destContainer: headingsContainer, 
      content: 'Subheading', 
      size: 60, 
      textAnimation: textAnimations.none, 
      perX: 0.5, 
      perY: 0.18, 
      // maxWidth: 0.15,
      minHeight: 0.08
    }
  );
  const arrowLeft = new ViewportSprite(
    {
      destContainer: headingsContainer, 
      spriteRef: 'arrowLeft',
      perX: 0.35, 
      perY: 0.21, 
      minHeight: 0.055,
      hitAreaMult: 2,   
      clickFunction: () => transitionPage(false)
    }
  )
  const arrowRight = new ViewportSprite(
    {
      destContainer: headingsContainer, 
      spriteRef: 'arrowRight',
      perX: 0.65, 
      perY: 0.21, 
      minHeight: 0.055,   
      hitAreaMult: 2,
      clickFunction: () => transitionPage(true)
    }
  )
  menuIndicator = new ViewportText(
    {
      destContainer: headingsContainer, 
      content: '● ○ ○', 
      size: 60, 
      textAnimation: textAnimations.none, 
      perX: 0.5, 
      perY: 0.23, 
      // maxWidth: 0.15,
      minHeight: 0.05
    }
  );

  gearContainer.addChild(headingsContainer);
  headingsContainer.y = -1000; //set arbitary amount off-screen
  
  gear.rotate = 0.01;
  world.rotate = 0;
  reserves.rotate = 0;
  arrowLeft.rotate = 0;
  arrowRight.rotate = 0;

  gear.attachment.zIndex = 2;
  gear.zIndex = 2;
  help.attachment.zIndex = 2;
  help.zIndex =2;
  world.attachment.zIndex = 2;
  world.zIndex = 2;

  // const textTest2 = new ViewportText(
  //   {
  //     destContainer: mainContainer, 
  //     content: 'Placeholder', 
  //     size: 220, 
  //     textAnimation: textAnimations.none, 
  //     perX: 0.5, 
  //     perY: 0.8, 
  //     minWidth: 0.5
  //   }
  // );
  const title = new ViewportText(
    {
      destContainer: mainContainer, 
      content: 'Bad Jam', 
      size: 60, 
      textAnimation: textAnimations.wave, 
      perX: 0.5, 
      perY: 0.16, 
      minWidth: 0.4
    }
  );
  // const textTest = new ViewportText(
  //   {
  //     destContainer: mainContainer, 
  //     content: 'helllo everyone', 
  //     size: 60, 
  //     textAnimation: textAnimations.wave, 
  //     perX: 0.5, 
  //     perY: 0.5, 
  //     minWidth: 0.3
  //   }
  // );
  // const textTest3 = new ViewportText(
  //   {
  //     destContainer: mainContainer, 
  //     content: 'Press Spacebar!', 
  //     size: 60, 
  //     textAnimation: textAnimations.none, 
  //     perX: 0.5, 
  //     perY: 0.55, 
  //     minWidth: 0.2,
  //     clickFunction: moveEverything
  //   }
  // );
  // const textTest4 = new ViewportText(
  //   {
  //     destContainer: mainContainer, 
  //     content: '...or click me!', 
  //     size: 60, 
  //     textAnimation: textAnimations.none, 
  //     perX: 0.5, 
  //     perY: 0.62, 
  //     minWidth: 0.08,
  //     clickFunction: moveEverything
  //   }
  // );
  

  console.log("Everything here V")
  console.log(mainContainer)

  let mouseTarget = [2];
  mouseTarget [0] = 0.5;
  mouseTarget[1] = 0.5;

  //running instantly outside of animation frame prevents render errors
  for (const instance of viewportInstances) {
    // instance.zIndex = 0;
    instance.resize();
    instance.updateLighting();
    instance.updatePixel();
  }

  let hideText= false;

  mainContainer.sortChildren();

  //mouse press handling
  window.addEventListener('pointerdown', () => {
    mouseDown = true;
  });

  window.addEventListener('pointerup', () => {
    mouseDown = false;
  });

  window.addEventListener('pointercancel', () => {
    mouseDown = false;
  });

  

  menu.zIndex = 1;
  gear.attachment.zIndex = 2;

  mainContainer.sortChildren();

  const step = () => {

    mousePos[2] = (mousePos[2]*12+mouseTarget[0])/13;
    mousePos[3]  = (mousePos[3]*12+mouseTarget[1])/13;    
    mousePos[0] = mousePos[2]
    mousePos[1] = mousePos[3]

    //gear.attachment.bounds = oldBounds;

    if (mouseDown) {
      if (heldDuration < 1.3) {
        heldDuration += 0.1;
      }
    } else {
      if (heldDuration > -0.2) {
        heldDuration -= 0.2;
      }
      if (heldDuration < -0.4) heldDuration = -0.4;
    }

    for (const instance of viewportInstances) {
        instance.updateLighting(); //should move this to mouse movements
        if (hideText && instance.staticBounds) {
          instance.attachment.alpha = Math.max(0, instance.attachment.alpha - 0.05);
        } else {
          instance.attachment.alpha = Math.min(1, instance.attachment.alpha + 0.05);
        }
        instance.updateLighting(); 
    }

    requestAnimationFrame(step);
    
  }

  requestAnimationFrame(step);

  mouseTarget[0] = app.screen.width/2
  mouseTarget[1] = app.screen.height/2

  

  app.stage.on('pointermove', (e) => {
    
    mouseTarget[0] = e.global.x
    mouseTarget[1] = e.global.y
    
  })

  let bunnyStage = false;

  
  window.addEventListener('keydown', (e) => {
    if (e.code === 'Space' && !e.repeat) {
      moveEverything()
    }
    if (e.key === 'Escape' && !e.repeat) {
      menu.activate()
    }
    if (e.key === '`') hideText = true;
    if (e.key === `¬`) hideText = !hideText;
    if (e.key === `>`) transitionPage(true);
  });

  window.addEventListener('keyup', (e) => {
    if (e.key === '`') hideText = false;
    if (e.key === `#`) {
      console.log("Palette quick-swap")
      const paletteSetting = findSettingByID(1);
      if (paletteSetting === undefined || paletteSetting.type !== 'select') return;
      const currentPaletteID = settingValue(paletteSetting)
      if (currentPaletteID === undefined) return;
      if (currentPaletteID === paletteSetting.options.length - 1) {
        paletteSetting.value.set( settings[0].selectedProfile, 0)
      } else {
        paletteSetting.value.set( settings[0].selectedProfile, currentPaletteID + 1)
      }
      saveSettings(paletteSetting);
    }
  });

  document.addEventListener('mousemove', () => {
    
  })

  /**
   * Brings up desired menu page, or transitions if menu is already open.
   * @param buttonNumber - page to open
   */
  function menuButton(buttonNumber: number) {
    if (transitionPageGroup(buttonNumber)) {
      if (!menu.isActive) {
        menu.activate();
      }
    } else {
      menu.activate();
    }
    // if (pageOpen === buttonNumber) {
    //   menu.activate();
    // } else {
    //   transitionPageGroup(buttonNumber);
    //   // transitionPage(buttonNumber)
    //   if (!menu.isActive) {
    //     menu.activate()
    //   }
    // }
  }

  function moveEverything() {
    if (!bunnyStage) {
      //bunny.moveTo(0.2,0.2,4)
      // textTest.moveTo(0.25,0.75,2)
      // textTest2.moveTo(0.6,0.4,2);
      // world.moveTo(0.12, 0.00, 2);
    } else {
      //bunny.moveTo(0.5,0.5,10)
      // textTest.moveTo(0.75,0.25,1 )
      // textTest2.moveTo(0.1,0.8,4);
      // world.moveTo(0.12, 0.2, 2);
    }

    bunnyStage = !bunnyStage
  }

  return mainContainer
}